import React from 'react';

const IntroductCompany = ({ profile }) => {
  return (
    <div className='text' style={{ paddingBottom: 50 }}>
      <div
        dangerouslySetInnerHTML={{ __html: profile?.description }}
        style={{ marginTop: '30px' }}
      />
      <div
        style={{
          marginTop: '10px',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
        }}
      >
        <div
          style={{ marginRight: '5px' }}
          className='fb-share-button'
          data-href={window.location.href}
          data-layout='button_count'
          data-size='large'
        >
          <a
            target='_blank'
            href={`https://www.facebook.com/sharer/sharer.php?u=${window.location.href};src=SMEdx`}
            className='fb-xfbml-parse-ignore'
          >
            Share
          </a>
        </div>
        <a
          className='twitter-share-button'
          href='https://twitter.com/intent/tweet'
          data-size='large'
        >
          Tweet
        </a>
      </div>
    </div>
  );
};
export default IntroductCompany;
